import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import { useParams } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
// import "../Profile.css";


import contentfolder from "../../../contentImgs/folder.png";
import loadable from '@loadable/component';
import {X,Plus ,Star,BookmarkPlus,Phone,Check,Video,MonitorPlay,BookOpenCheck,
    TabletSmartphone,NotebookPen,BookDown,NotepadText,BookA,GalleryHorizontal,BadgePlus,Aperture,Blocks,CalendarCog,
    Trash2} from 'lucide-react';
import Loading from "../../../Loading/Loading";
import Snackbar from "../../../../Snackbar";
import LoadingButton from "../../../Loading/LoadingButton";
import ContentFolderCard from "../ContentFolderCard";
import Toggle from "../../../UI/Toggle";
import FolderForQuiz from "./FolderForQuiz";
import { createNewMockTest, getQuizDataByQuizId } from "../../../../store/actions/CreateContent/QuizAPI/createNewMockTest";
import QuizSetUpOuter from "./QuizSetUpOuter";
import HighlightsQuiz from "./HighlightsQuiz";
import FAQsQuiz from "./FAQsQuiz";
import RichTextCardPopUp from "./RichTextCardPopUp";

// npm i @loadable/component 
let lazyLoad =   <Loading/>;
  ;

 const BasicInfoQuiz= ({quizObjectID,setQuizObjectDataBack})=>{
    // const {category} = useParams();
   

    const App = useSelector((state)=>state?.app?.app);
    const [Courses,setCourses] =useState([])
    const [CoursesBlank,setCoursesBlank] =useState([{},{},{},{},{}])
     const [animate, setAnimate] = useState(false);
     
    const dispatch = useDispatch();  
  
    const currentToken = useSelector((state)=>state?.user?.user?.token);
    const user_email = useSelector((state)=>state?.user?.user?.user_email
   );
   const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
   const appId = useSelector((state)=>state?.app?.app?.ID);
   const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
        
   const [snackbarVisible, setSnackbarVisible] = useState(false);
    
    const [snackbarColor, setSnackbarColor] = useState("#958FDA");
    const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
    const showSnackbar = () => {
     setSnackbarVisible(true);
   };
   
    const hideSnackbar = () => {
     setSnackbarVisible(false);
   };
   const setCurrentCourse=()=>{
    dispatch({
        type: "COURSEDATA",
        
        payload:""
      });  
}
       const [loader , setLoader] =useState({status:false});
      const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
          {
            
            dispatch({type: "CURSOR",payload:true  });
        
            dispatch({type: "CURSORTEXT",payload:CursorText})
            dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
            dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
          }
           
          const handleMouseLeave = () => {
            
            dispatch({type: "CURSOR",payload:false})
        
            dispatch({type: "CURSORTEXT",payload:""})
        
            dispatch({type: "CURSORTEXTBG",payload:""})
            dispatch({type: "CURSORTEXTCOLOR",payload:""})
          
        
        } 
    
      const [goNextPopUp, setGoNextPopUp] =useState(false);
     
     const [activeStep, setActiveStep] = useState(0);
     const [activeSubStepOne, setActiveSubStepOne] = useState(3);
     
     const [activeSubStepTwo, setActiveSubStepTwo] = useState(0);
     const [activeSubStepThree, setActiveSubStepThree] = useState(0);
     const [activeSubStepFour, setActiveSubStepFour] = useState(0);
     const [activeSubStepFive, setActiveSubStepFive] = useState(0);
     const [titleActive, setTitleActive] = useState(true);
     const [desctiptionActive, setDesctiptionActive] = useState(false);
     const [highlightActive, setHighlightActive] = useState(false);
     const [FAQActive, setFAQActive] = useState(false);
    
    const steps = ([{number:1,name:"Title"},{number:2,name:"Description"},{number:3,name:"Highlights"},{number:4,name:"FAQs"}]);
    const subSteps = [1, 2, 3, 4, 5];
    const subStepOneTotal= 3;
    const subStepTwoTotal= 3;
    const subStepThreeTotal= 3;
    const subStepFourTotal= 3;
    const subStepFiveTotal= 3;
    ;
        const [sellAsTestSeries, setSellAsTestSeries] = useState(false);
   
        const [folderForQuizPopUp, setFolderForQuizPopUp] = useState(false);
        const [folderForQuizPopUpCreateFolder, setFolderForQuizPopUpCreateFolder] = useState(false);
        const [parentFolder, setParentFolder] = useState({ID:""});
        
        
        const [quizName, setQuizName] = useState("");
        const [quizDescription,  setQuizDescription] = useState("");
        const [higlights,  setHiglights] = useState([]);
        const [FAQs,  setFAQs] = useState([]);
        
        const [quizID, setQuizID] = useState("");
        const [quizObject, setQuizObject] = useState({});
   
    const userdata = useSelector((state)=>state?.user?.user);
   useEffect(()=>{
   
   fireGetQuizDataByQuizId()
   
   },[])
   useEffect(()=>{
   
    setAnimate(false);  
    const timer = setTimeout(() => {
     setAnimate(true);  
   }, 1000);
 
    return () => clearTimeout(timer); 
    },[titleActive,desctiptionActive,highlightActive,FAQActive])
   const fireGetQuizDataByQuizId=()=>{
   
    setLoader({status:true});
    
      const apiData = dispatch(getQuizDataByQuizId({testName:quizName,type:"mock",
        postParent:"",userEmail:user_email?user_email:"",
        currentToken:currentToken?currentToken:"",
        editType:"",postId:quizObjectID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
        ));
      /* get response as Promise   */
      apiData.then(response => {
        if(response){  
          //  console.log(response)
          //  thumbnail,PDFlink
          if(response?.quiz){
            
        setResponseMessage(response?.message);
        setSnackbarColor("rgba(144, 202, 249,1)");
      setQuizObject(response?.quiz)
      setQuizName(response?.quiz?.testName)
      setQuizDescription(response?.quiz?.descripton)
      setHiglights( response?.quiz?.higlights?JSON.parse(response?.quiz?.higlights):[])
      setFAQs( response?.quiz?.FAQs?JSON.parse(response?.quiz?.FAQs):[])
      setLoader({status:false});
    
  
       }else{
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
       }
          
       
       if(response?.logout){
       
        setResponseMessage("You are Logged Out!!!");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        setTimeout(()=>{
          dispatch({type:"LOGOUT"});
    
        },3000)
        
      }
    /* resetting Login input Fields */
    
        }else{
          setResponseMessage("Something Went Wrong...");
          
          setSnackbarColor("#958FDA");
       
           
      setLoader({status:false});
      
      setSnackbarVisible(true);
      setTimeout(()=>{
        
        setSnackbarVisible(false);
       
         
      },3000)    }
    
      }).catch(error => {
     
        //popup of error Info
        setResponseMessage("Something Went Wrong...");
          
        setSnackbarColor("#958FDA");
     
         
    setLoader({status:false});
    
    setSnackbarVisible(true);
    setTimeout(()=>{
      
      setSnackbarVisible(false);
     
       
    },3000)
        console.error(error);
      });
     
      }
     const handleCreateNewMockTest=(editType)=>{
     let SendObject=""
     if(editType=="testName"){
        SendObject={testName:quizName,type:"mock",
            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
            currentToken:currentToken?currentToken:"",
            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
             }
             
             if(editType=="descripton"){
                SendObject={descripton:quizDescription,type:"mock",
                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                    currentToken:currentToken?currentToken:"",
                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                     }
                     if(editType=="higlights"){
                        SendObject={higlights:JSON.stringify(higlights),type:"mock",
                            postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                            currentToken:currentToken?currentToken:"",
                            editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                             }
                             if(editType=="FAQs"){
                                SendObject={FAQs:JSON.stringify(FAQs),type:"mock",
                                    postParent:parentFolder?.ID,userEmail:user_email?user_email:"",
                                    currentToken:currentToken?currentToken:"",
                                    editType:editType,postId:quizObject?.ID,menuOrder:"0",appToken:AppToken,appId:appId,appAllottedToken:appAllottedToken}
                                     }
                     
     setLoader({status:true});
     
       const apiData = dispatch(createNewMockTest(SendObject));
       /* get response as Promise   */
       apiData.then(response => {
         if(response){   
           if(response?.quiz){
             
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
       setQuizObject(response?.quiz)
       
       setQuizDescription(response?.quiz?.descripton)

       setHiglights( response?.quiz?.higlights?JSON.parse(response?.quiz?.higlights):[])
       setFAQs( response?.quiz?.FAQs?JSON.parse(response?.quiz?.FAQs):[])
    
       setQuizObjectDataBack(response?.quiz)
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
       if(editType=="testName"){
        setQuizName(response?.quiz?.testName); setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
        setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0); }
        if(editType=="descripton"){
      
            setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
         
            } if(editType=="higlights"){
      
                setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
                setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
              
                }
        
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
       
   
       return <>
       
   
 
   {snackbarVisible && (
        <Snackbar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}  
       <div   className=" progress-bar-container "style={{position:"relative",zIndex:"99"}}> 
   <div className="progress-bark">
        {steps?.map((step) => (<div className="animCirclek"  onMouseEnter={
                               ()=>handleMouseEnter("#fff","#333","")}
     onMouseLeave={handleMouseLeave}  onClick={()=>{
        if(step?.number==1){ setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==2){  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
          }else if(step?.number==3){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
          }else if(step?.number==4){  setTitleActive(false);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(true);
            setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(3);
          }
        }} style={{position:"relative"}} key={step?.number}>
          <div
            
            className={`circlek ${step?.number <= activeStep ? "activek" : ""}` }
            style={{background: `${step?.number ===1?
              `${activeSubStepOne?`conic-gradient(#565283 0% ${activeSubStepOne*100/subStepOneTotal}%, #ffffff 
                                                ${activeSubStepOne*100/subStepOneTotal}% 100%)`:""}`:
                                                step?.number ===2?
                                                `${activeSubStepTwo?`conic-gradient(#565283 0% 
                                                ${activeSubStepTwo*100/subStepTwoTotal}%, #ffffff 
                                                ${activeSubStepTwo*100/subStepTwoTotal}% 100%)`:""}`: 
                                                step?.number ===3?
                                                `${activeSubStepThree?`conic-gradient(#565283 0% 
                                                ${activeSubStepThree*100/subStepThreeTotal}%, #ffffff 
                                                ${activeSubStepThree*100/subStepThreeTotal}% 100%)`:""}`
                                                :step?.number ===4?
                                                `${activeSubStepFour?`conic-gradient(#565283 0% 
                                                ${activeSubStepFour*100/subStepFourTotal}%, #ffffff 
                                                ${activeSubStepFour*100/subStepFourTotal}% 100%)`:""}`:
                                                step?.number ===5?
                                                `${activeSubStepFive?`conic-gradient(#565283 0% 
                                                ${activeSubStepFive *100/subStepFiveTotal}%, #ffffff 
                                                ${activeSubStepFive*100/subStepFiveTotal}% 100%)`:""}`:""}
            `}} 
          ><div   className={`circlekInn `}>
             {step?.number}
          </div>
          <div align="center" style={{width:"110px",position:"absolute",top:"55px",fontSize:"14px"}}>{step?.name}</div>
          </div></div>
        ))}<div style={{width:"95%",height:"5px",background:"rgb(86, 82, 131)",position:"absolute",left:"0px",top:"25px",right:"0px"}}></div>
      </div>  
    
      </div>
      <div  className=""style={{marginTop:"40px"}}><div  className=" " style={{background:"#fff",borderRadius:"25px",paddingBottom:"50px"}}>

 {titleActive?
    <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Add Quiz  <span className="coloredTextV1" > Name </span></h2>
   
 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox" style={{
        transform: animate ? 'translateY(0)' : 'translateY(-20px)',
        opacity: animate ? 1 : 0.5,
        transition: 'transform 2s ease, opacity 1s ease',
      fontSize:"25px"}} placeholder={`Add Quiz Name`} type="text"
  rows={2} name="courseTitle" value={quizName} onChange={(e)=>setQuizName(e.target.value)} />
 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><div></div>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewMockTest("testName");}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
</div>
</div> </div>:""}
 
{desctiptionActive?
    <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Add Test <span className="coloredTextV1" > Description </span></h2>
   
 {/* <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="CreateCourseStepsOuterTextbox"  style={{
        transform: animate ? 'translateY(0)' : 'translateY(-20px)',
        opacity: animate ? 1 : 0.5,
        transition: 'transform 2s ease, opacity 1s ease',
      fontSize:"25px"}} placeholder={`Add Test Description`} type="text"
  rows={6} name="courseTitle" value={quizDescription} onChange={(e)=>setQuizDescription(e.target.value)} /> */}

<div style={{"textAlign":"center",
     top: animate ? '0px' : '20px',position:"relative",
     opacity: animate ? 1 : 0.5,
     transition: 'top 1s ease, opacity 1s ease',
   marginTop:"-50px"}}><RichTextCardPopUp hidePopUp={true} contentType="quizDescription" cardTitle="" cardTitleColor=""
 setRichTextPopUp={()=>{}} postParentId={quizObjectID}/> </div>


 </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'13px',fontSize:'12px',marginBottom:'10px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"5px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setTitleActive(true);setDesctiptionActive(false); setHighlightActive(false); setFAQActive(false);
    setActiveSubStepOne(3);   setActiveSubStepTwo(0); setActiveSubStepThree(0); setActiveSubStepFour(0);}}   className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewMockTest("descripton");}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
</div>
</div> </div>:""}
 {highlightActive? <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Highlight Important Points About Your <span className="coloredTextV1" > Quiz </span></h2>
      
   <HighlightsQuiz highlightsData={higlights} sendBackData={(itemArray)=>{setHiglights(itemArray)}} /> </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',background:"#ffffff",fontSize:'12px',marginBottom:'2px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"12px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{  setTitleActive(false);setDesctiptionActive(true); setHighlightActive(false); setFAQActive(false);
    setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(0); setActiveSubStepFour(0);
  }}   className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewMockTest("higlights");}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
</div>
</div> </div>
 :""}

{FAQActive? <div>
<div  className="ikcraft_login-input-card">
<h2 style={{"textAlign":"center",
     transform: animate ? 'translateY(0)' : 'translateY(-20px)',
     opacity: animate ? 1 : 0.5,
     transition: 'transform 1s ease, opacity 1s ease',
   }}> Add FAQs For Your <span className="coloredTextV1" > Quiz </span></h2>
      
   <FAQsQuiz FAQsData={FAQs} sendBackData={(itemArray)=>{setFAQs(itemArray)}} /> </div>
 <div className="CreateCourseStepsOuterBottom" style={{padding:'15px',background:"#ffffff",fontSize:'12px',marginBottom:'2px',zIndex:"99999999"}}>
    <div  >   </div>
  
    <div align="center" className="" style={{position:"absolute",left:"0px",right:"30px",bottom:"12px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"0px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}><button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{   setTitleActive(false);setDesctiptionActive(false); setHighlightActive(true); setFAQActive(false);
    setActiveSubStepOne(3);   setActiveSubStepTwo(3); setActiveSubStepThree(3); setActiveSubStepFour(0);
    
  }}   className=" CoursesPreviewTopBtn"  type="submit"
 > Back </button>
<button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{handleCreateNewMockTest("FAQs");}}  style={{position:"relative",background:"rgba(144, 202, 249,1)",padding:"10px",color:"#fff",width:"140px",cursor:"pointer",zIndex:99999,height:"55px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > {<LoadingButton  Load={loader?.status}/>} {loader?.status?"":"Save And Next"} </button>
</div>
</div> </div>
 :""} 
    
 <div>
     </div>
    
    </div>
    </div>
     </>


}
export default BasicInfoQuiz;